import React from "react";
import classNames from "classnames";
import { Spinner } from "react-bootstrap";

interface IProps {
    readonly isActive?: boolean;
    readonly id?: string;
    readonly className?: string;
}
interface IState {}

export default class LoadingIndicator extends React.Component<IProps, IState> {
    public static defaultProps: IProps = {
        isActive: false,
        id: undefined,
        className: undefined,
    };

    public render(): JSX.Element {
        const { children, isActive, id, className } = this.props;

        return (
            <div className={classNames(className, { "loader-wrapper": isActive })} id={id}>
                {isActive && (
                    <div className="loader-container">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                )}
                {children}
            </div>
        );
    }
}
